export default __webpack_public_path__ + "static/media/raki_detail10.8124e343.jpg";